export enum FORM_MODE {
  CREATE = "CREATE",
  EDIT = "EDIT",
  VIEW = "VIEW",
  DELETE = "DELETE",
}
